import { FlattenInterpolation, ThemedStyledProps } from 'styled-components';

import primary from './primary';
import secondary from './secondary';
import tertiary from './tertiary';
import tag from './tag';
import clean from './clean';

import { ButtonVariant } from '../types';
import { ButtonBaseProps } from '../Button';

export const buttonThemes: {
  [key in ButtonVariant]: FlattenInterpolation<ThemedStyledProps<ButtonBaseProps, any>>;
} = {
  primary,
  secondary,
  tertiary,
  tag,
  clean,
};

export const applyButtonTheme: any = ({ variant }: { variant: ButtonVariant }) => buttonThemes[variant];
